module.exports = __webpack_public_path__ + "static/media/img-location-taipei-zh.6b3bb043.svg";